import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const keyValueVariants = cva("key-value", {
  variants: {
    inline: {
      true: "key-value--inline",
    },
    columns: {
      true: "key-value--columns",
    },
    grid: {
      true: "key-value--grid",
    },
  },
})

export interface KeyValueProps extends React.HTMLAttributes<HTMLDListElement>, VariantProps<typeof keyValueVariants> {}

const KeyValue = React.forwardRef<HTMLDListElement, KeyValueProps>(
  ({ className, inline, grid, columns, ...props }, ref) => {
    return <dl ref={ref} className={cn(keyValueVariants({ className, inline, grid, columns }))} {...props} />
  },
)
KeyValue.displayName = "KeyValue"

const KeyValueItem = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} className={cn("key-value__item", className)} {...props} />
  },
)
KeyValueItem.displayName = "KeyValueItem"

const KeyValueTitle = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => {
    return <dt ref={ref} className={cn("key-value__title", className)} {...props} />
  },
)
KeyValueTitle.displayName = "KeyValueTitle"

const KeyValueDescription = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => {
    return <dd ref={ref} className={cn("key-value__desc", className)} {...props} />
  },
)
KeyValueDescription.displayName = "KeyValueDescription"

export { KeyValue, KeyValueItem, KeyValueTitle, KeyValueDescription }
